import { ResolverTag } from '@ps/web-core-enums';
import { Translation, useResolver } from '@ps/web-shared-components';
import React, { useState } from 'react';

import StarsButton from '@swf/components/StarsButton/StarsButton';

import {
  TXTCLI_If_you_enjoy_Spin_X_GoX_downlo_ELL,
  TXTMOB_Download_PokerStars
} from './DownloadPSBanner.messages.json';
import styles from './DownloadPSBanner.scss';

const DownloadPSBanner = () => {
  const downloadLink = useResolver(ResolverTag.PSDownload);
  const [loading, setLoading] = useState<boolean>(false);
  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <span className={styles.text}>
          <Translation {...TXTCLI_If_you_enjoy_Spin_X_GoX_downlo_ELL} />
        </span>
        <StarsButton
          target="_blank"
          rel="noopener noreferrer"
          href={downloadLink}
          variant="secondary"
          loading={loading}
          disabled={!downloadLink}
          translation={TXTMOB_Download_PokerStars}
          className={styles.button}
          onClick={() => {
            setLoading(true);
            setTimeout(() => setLoading(false), 1000);
          }}
        />
      </div>
    </div>
  );
};

export default DownloadPSBanner;
